import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TPatchSegmentLogo, TSegmentLogo } from '../types';

export type TPatchSegmentLogoBody = {
  id: string;
  body: TPatchSegmentLogo;
  silently?: boolean;
};

export async function patchSegmentLogo({ id, body }: TPatchSegmentLogoBody): Promise<TSegmentLogo> {
  return mediaManagerClient
    .patch(`/api/v1/segment_logos/${id}`, emptyStringValues(body))
    .then(response => response as unknown as TSegmentLogo);
}

type MutationFn = typeof patchSegmentLogo;

type TUsePatchSegmentLogoParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePatchSegmentLogo({ config }: TUsePatchSegmentLogoParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: ({ id, body, silently = false }: TPatchSegmentLogoBody) =>
      patchSegmentLogo({ id, body, silently }),
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar el logo del segmento'));
      console.error(error);
    },
    onSuccess(_data, variables: TPatchSegmentLogoBody) {
      if (!variables.silently) {
        addSuccessNotification(t('Logo(s) del segmento actualizado(s) correctamente'));
      }
    },
  });
}
